import {
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import { CitymapApi } from './CitymapApi';
import { Layer } from '../types';

export class CitymapClient implements CitymapApi {

  private readonly fetchApi: FetchApi;
  private readonly discoveryApi: DiscoveryApi;

  constructor(options: { fetchApi: FetchApi; discoveryApi: DiscoveryApi; }) {
    this.fetchApi = options.fetchApi;
    this.discoveryApi = options.discoveryApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('citymap');
  }

  async getLayers(): Promise<Layer[]> {
    const url = `${await this.getBaseUrl()}/`;
    const response = await this.fetchApi.fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch layers: ${response.statusText}`);
    }

    return response.json();
  }
}